// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.basic-data-info__new-button {
    background: var(--secondary-color);
    border-radius: 2px;
}

.basic-data-info__new-button:hover {
    background: var(--hover-pb-bg-color);
}

.basic-data-info__team {
    display: flex;
    margin-top: var(--space);
}
.basic-data-info__team__icon {
    width: var(--space-and-half);
    height: var(--space-and-half);
    margin-right: var(--space-half);
}
.basic-data-info__data {
    margin-top: var(--space);
    display: grid;
    grid-gap: var(--space-and-half);
    grid-template-columns: repeat(5, 1fr);
}
.basic-data-info__data__positions-graph {
    grid-column-start: 1;
    grid-column-end: 3;
}

.basic-data-info__data__positions-graph__field img {
    width: 100%;
}
/* .basic-data-info__data__info {
    grid-column-start: 3;
    grid-column-end: end;
} */

.basic-data-info__data__info__dates {
    grid-column-start: 3;
    grid-column-end: end;
    display: flex;
    margin-bottom: var(--space-and-half);    
}

.basic-data-info__data__info__dates__date {
    width: calc( calc( var(--space-x3) *2 ) + var(--space));
    margin-right: var(--space);
}

.basic-data-info__data__info__container {
    margin-top: calc(var(--space) * 4);
    padding: 0 var(--space-x2) var(--space-x2) var(--space-x2);
}
.basic-data-info__data__info__container_left {
    grid-area: left;
}
.basic-data-info__data__info__container_center {
    display: grid;
    grid-auto-rows: 1fr;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr;
    grid-gap: 0% 6em;
    gap: 0% 6em;
    width: 90%;
    margin: auto;
}
.basic-data-info__data__info__container_right {
    display: flex;
    justify-content:flex-end;
}

.basic-data-info-report-resume-left-col{
    justify-self: start;
}

.basic-data-info-report-resume-right-col{
    justify-self: start;
}

.basic-data-info-report-resume-item-text {
    padding-bottom: var(--space);
    width: auto;
}

.basic-data-info__data__title__container {
    margin-bottom: var(--space);
    margin-left: var(--space-x3);
}

.basic-data-info-report-resume-item-text .baloa-table {
    color: var(--primary-dark-color);
}

.basic-data-info-report-resume-item-text .baloa-names {
    color: var(--primary-very-dark-color);
}

.basic-data-info-report-resume-item-text-icon {
    display: flex;
}

.basic-data-info-report-resume-item-text-icon p{
    margin-right: 5px;
}

.basic-data-info__data__info {
    margin-bottom: var(--space-and-half);
    
}
.basic-data-info__data__info__label.baloa-username {
    color: var( --basic-gray-color );
    height: var( --space-and-half );
    display: flex;
    align-items: center;
}

.basic-data-info__data__info.gender-category,
.basic-data-info__data__info.country-city,
.basic-data-info__data__info.dates {
    display: flex;
    justify-content: space-between;
    width: 85%;
}

.basic-data-info__data__info.gender-category div,
.basic-data-info__data__info.country-city div,
.basic-data-info__data__info.dates div {
    width: 100%;
}
.basic-data-info__data__info__value.baloa-table {
    color: var( --primary-very-dark-color );
    height: var( --space-and-half );
    display: flex;
    align-items: center;
}

.basic-data-info__data__info__value.description {
    display: contents;
}

/*Fix TournamentEditTournamentComponent*/
.tabpanel-line .basic-data-info__data__info__container{
    padding: 0 var(--space-x2) var(--space-x2) var(--space-x2);
}`, "",{"version":3,"sources":["webpack://./src/app/leagues/components/tournament-basic-data-info/TournamentBasicDataInfoComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,kCAAkC;IAClC,kBAAkB;AACtB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,aAAa;IACb,wBAAwB;AAC5B;AACA;IACI,4BAA4B;IAC5B,6BAA6B;IAC7B,+BAA+B;AACnC;AACA;IACI,wBAAwB;IACxB,aAAa;IACb,+BAA+B;IAC/B,qCAAqC;AACzC;AACA;IACI,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;IACI,WAAW;AACf;AACA;;;GAGG;;AAEH;IACI,oBAAoB;IACpB,oBAAoB;IACpB,aAAa;IACb,oCAAoC;AACxC;;AAEA;IACI,uDAAuD;IACvD,0BAA0B;AAC9B;;AAEA;IACI,kCAAkC;IAClC,0DAA0D;AAC9D;AACA;IACI,eAAe;AACnB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,uBAAuB;IACvB,gBAAgB;IAChB,WAAW;IACX,UAAU;IACV,YAAY;AAChB;AACA;IACI,aAAa;IACb,wBAAwB;AAC5B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,4BAA4B;IAC5B,WAAW;AACf;;AAEA;IACI,2BAA2B;IAC3B,4BAA4B;AAChC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,oCAAoC;;AAExC;AACA;IACI,gCAAgC;IAChC,+BAA+B;IAC/B,aAAa;IACb,mBAAmB;AACvB;;AAEA;;;IAGI,aAAa;IACb,8BAA8B;IAC9B,UAAU;AACd;;AAEA;;;IAGI,WAAW;AACf;AACA;IACI,uCAAuC;IACvC,+BAA+B;IAC/B,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA,wCAAwC;AACxC;IACI,0DAA0D;AAC9D","sourcesContent":[".basic-data-info__new-button {\n    background: var(--secondary-color);\n    border-radius: 2px;\n}\n\n.basic-data-info__new-button:hover {\n    background: var(--hover-pb-bg-color);\n}\n\n.basic-data-info__team {\n    display: flex;\n    margin-top: var(--space);\n}\n.basic-data-info__team__icon {\n    width: var(--space-and-half);\n    height: var(--space-and-half);\n    margin-right: var(--space-half);\n}\n.basic-data-info__data {\n    margin-top: var(--space);\n    display: grid;\n    grid-gap: var(--space-and-half);\n    grid-template-columns: repeat(5, 1fr);\n}\n.basic-data-info__data__positions-graph {\n    grid-column-start: 1;\n    grid-column-end: 3;\n}\n\n.basic-data-info__data__positions-graph__field img {\n    width: 100%;\n}\n/* .basic-data-info__data__info {\n    grid-column-start: 3;\n    grid-column-end: end;\n} */\n\n.basic-data-info__data__info__dates {\n    grid-column-start: 3;\n    grid-column-end: end;\n    display: flex;\n    margin-bottom: var(--space-and-half);    \n}\n\n.basic-data-info__data__info__dates__date {\n    width: calc( calc( var(--space-x3) *2 ) + var(--space));\n    margin-right: var(--space);\n}\n\n.basic-data-info__data__info__container {\n    margin-top: calc(var(--space) * 4);\n    padding: 0 var(--space-x2) var(--space-x2) var(--space-x2);\n}\n.basic-data-info__data__info__container_left {\n    grid-area: left;\n}\n.basic-data-info__data__info__container_center {\n    display: grid;\n    grid-auto-rows: 1fr;\n    grid-template-columns: 1fr 1fr;\n    grid-template-rows: 1fr;\n    grid-gap: 0% 6em;\n    gap: 0% 6em;\n    width: 90%;\n    margin: auto;\n}\n.basic-data-info__data__info__container_right {\n    display: flex;\n    justify-content:flex-end;\n}\n\n.basic-data-info-report-resume-left-col{\n    justify-self: start;\n}\n\n.basic-data-info-report-resume-right-col{\n    justify-self: start;\n}\n\n.basic-data-info-report-resume-item-text {\n    padding-bottom: var(--space);\n    width: auto;\n}\n\n.basic-data-info__data__title__container {\n    margin-bottom: var(--space);\n    margin-left: var(--space-x3);\n}\n\n.basic-data-info-report-resume-item-text .baloa-table {\n    color: var(--primary-dark-color);\n}\n\n.basic-data-info-report-resume-item-text .baloa-names {\n    color: var(--primary-very-dark-color);\n}\n\n.basic-data-info-report-resume-item-text-icon {\n    display: flex;\n}\n\n.basic-data-info-report-resume-item-text-icon p{\n    margin-right: 5px;\n}\n\n.basic-data-info__data__info {\n    margin-bottom: var(--space-and-half);\n    \n}\n.basic-data-info__data__info__label.baloa-username {\n    color: var( --basic-gray-color );\n    height: var( --space-and-half );\n    display: flex;\n    align-items: center;\n}\n\n.basic-data-info__data__info.gender-category,\n.basic-data-info__data__info.country-city,\n.basic-data-info__data__info.dates {\n    display: flex;\n    justify-content: space-between;\n    width: 85%;\n}\n\n.basic-data-info__data__info.gender-category div,\n.basic-data-info__data__info.country-city div,\n.basic-data-info__data__info.dates div {\n    width: 100%;\n}\n.basic-data-info__data__info__value.baloa-table {\n    color: var( --primary-very-dark-color );\n    height: var( --space-and-half );\n    display: flex;\n    align-items: center;\n}\n\n.basic-data-info__data__info__value.description {\n    display: contents;\n}\n\n/*Fix TournamentEditTournamentComponent*/\n.tabpanel-line .basic-data-info__data__info__container{\n    padding: 0 var(--space-x2) var(--space-x2) var(--space-x2);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
